import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getCourseCompletionReports } from '../../../services/MoodleService';

export const useGetCourseCompletionReports = ({
  year,
  courseConfigId,
  state,
  employeeId,
  page = 0,
  size = 15,
} = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: moodleQueryKeys.courseCompletionReports(
      year,
      courseConfigId,
      state,
      employeeId,
      page,
      size,
    ),
    queryFn: () =>
      getCourseCompletionReports({ year, courseConfigId, state, employeeId, page, size }),
  });

  const reports = data?.data?.content || [];
  const totalElements = data?.data?.totalElements || 0;
  const totalPages = data?.data?.totalPages || 0;

  return {
    reports,
    totalElements,
    totalPages,
    loading: isLoading,
  };
};
